module.exports = __webpack_public_path__ + "static/media/1.037ac872.jpg";